import React from 'react';
import { ForgotPin } from '../../components/Forms/ForgotPin';
import { Home } from './Home';

export const ForgotPinPage = () => <Home><ForgotPin /></Home>;
